export enum AuthStrategy {
  Local = 'LOCAL',
  IAM = 'IAM',
}

export interface AvailableAuthStrategy {
  type: AuthStrategy;
  path: string;
  title: string;
}
